import React from "react";
import { Link } from "gatsby";
import { v4 as uuidv4 } from "uuid";

export default (props) => {
  const { archiveData, searchHandler, navigateOnFiltering } = props;
  const itemKey = uuidv4();

  return (
    <>
      <li key={itemKey} className="w-11/12 h-10 px-0 py-0 align-middle list-none border-b border-gray-100 last:border-b-0">
        <div className="inline-block w-10/12 text-left ">
          {navigateOnFiltering ? (
            <Link to="/blog" state={{ searchParams: { searchContext: "archive-search", searchTerm: archiveData.archiveDate } }}>
              <p className="text=gray-500 hover:text-gray-500 hover:underline">{archiveData.archiveDate}</p>
            </Link>
          ) : (
            <button className="text=gray-500 hover:text-gray-500 hover:underline" onClick={() => searchHandler({ searchContext: "archive-search", searchTerm: archiveData.archiveDate })}>
              <p className="text=gray-500 hover:text-gray-500 hover:underline">{archiveData.archiveDate}</p>
            </button>
          )}
        </div>
        <div className="inline-block w-2/12 text-right ">{/* <p className="text-blue-500">{`(${archiveData.numberOfPosts})`}</p> */}</div>
      </li>
    </>
  );
};
